export const version = { buildDate: '03.11.2026 08:38' };